import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import { performUpdateUserProfile, userProfilePropTypes } from '../userProfileDuck'
import { currentUserSuccess, currentUserPropTypes } from '../../../../store/shared/currentUserDuck'
import { getNestedProp } from '../../../../utils/ramda'
import fullstory from '../../../../utils/constants/fullstory'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'

class UserProfileCareerTargetForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showingInput: false,
    }

    this.toggleShowingInput = nextState => this.setState({ showingInput: nextState })

    this.handleFormSubmit = e => {
      this.props.handleSubmit(e)
      this.toggleShowingInput(false)
    }
  }
  render() {
    const { pristine, invalid, userProfile, currentUser } = this.props
    const { showingInput } = this.state

    return (
      <div>
        {userProfile.error && <h5 className="text-center text-danger">{userProfile.error}</h5>}
        {showingInput ? (
          <form>
            <div className="d-flex justify-content-between align-items-center">
              <Field
                className={fullstory.classNames.textInput}
                component={renderTextInputWithFeedback}
                name="jobTitle"
                placeholder="Career Target"
              />
              <button
                onClick={this.handleFormSubmit}
                className="btn btn-link"
                disabled={pristine || invalid}
              >
                Save
              </button>
              <button
                onClick={() => this.toggleShowingInput(false)}
                className="btn btn-link btn-sm"
              >
                Cancel
              </button>
            </div>
          </form>
        ) : (
          <div
            onClick={() => this.toggleShowingInput(true)}
            className="d-flex justify-content-between align-items-center"
          >
            <h6>
              Job Target:
              <span className="text-info">
                {' '}
                {getNestedProp('user.info.jobTitle', currentUser) || 'No Job Target Yet!'}
              </span>
            </h6>
          </div>
        )}
      </div>
    )
  }
}

UserProfileCareerTargetForm.propTypes = {
  currentUserSuccess: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  currentUser: currentUserPropTypes,
  userProfile: userProfilePropTypes,
  performUpdateUserProfile: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
}

UserProfileCareerTargetForm.defaultProps = {}

/**
 * @const validate
 * @desc Checks whether our form is valid
 * @param values
 * @returns {{}}
 */
const validate = values => {
  const errors = {}
  errors.jobTitle = formValidators.isRequired(values.jobTitle)
  return errors
}

/**
 * @const wrappedWithForm
 * @desc Gives SignupForm extra props like invalid, pristine, and handleSubmit
 */
const wrappedWithForm = reduxForm({
  form: 'userProfileCareerTargetForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      const { user } = await props.performUpdateUserProfile(values)
      props.currentUserSuccess(user)
      notificationsUtils.showSuccessNotification('Job Target Updated!')
    } catch (error) {
      notificationsUtils.showErrorNotification('There was a problem updating this field.')
    }
  },
  validate,
})(UserProfileCareerTargetForm)

/**
 * @const mapStateToProps
 * @param state
 */
const mapStateToProps = _state => ({
  userProfile: _state.userProfile,
  currentUser: _state.currentUser,
  initialValues: getNestedProp('user.info', _state.currentUser),
})

/**
 * @const mapDispatchToProps
 * @desc Binds an Action Performer to this.props
 * @param dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess,
      performUpdateUserProfile,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(wrappedWithForm)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/UserProfileCareerTargetForm.js